import { render, staticRenderFns } from "./UitvoeringWizard.vue?vue&type=template&id=e482e57c"
import script from "./UitvoeringWizard.vue?vue&type=script&lang=js"
export * from "./UitvoeringWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports